import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';

export interface InstallConfig {
    consumerDirectInstallUrl: string;
    consumerInstallLink: string;
    consumerSSUInstallLink: string;
    commercialMySoftwarePageUrl: string;
    dimeEnabled: boolean;
    dimeJSUrl: string;
    dimeTimeoutMs: number;
    goPremiumUrl: string;
    goPremiumUrlPremiumTemplates: string;
    welcomeBadgeOneDriveUrl: string;
    installApiRoot: string;
    installApiSWEnabled: boolean;
    pwaInstallMoveEnabled: boolean;
    resources: InstallResources;
    sendRequestId: boolean;
    shellGoPremiumUrl: string;
    wizardImageAssets: string;
    wizardSupportLink: string;
    buyOffice365Url: string;
    haveOfficeProductKeyUrl: string;
    needHelpInstallingOfficeUrl: string;
    ecsInstallNoLicenseOptionsEnabled: boolean;
    installMessagePopupEnabled: boolean;
    learnAboutM365Link: string;
    needHelpLink: string;
    paidConsumerSubscriptionBenefitsUrl: string;
}

export interface InstallResources {
    BuyMicrosoft365BtnText: string;
    GetOfficeAppsButtonAriaLabelAndroid: string;
    GetOfficeAppsButtonAriaLabelIpad: string;
    GetOfficeAppsButtonAriaLabelIphone: string;
    GetOfficeAppsButtonText: string;
    GoPremiumBtnText: string;
    GoPremiumDescription: string;
    HaveOfficeProductKeyLnkText: string;
    InstallAdditionalLinkAriaLabel: string;
    InstallAdditionalLinkDescription: string;
    InstallAdditionalLinkText: string;
    InstallConsumerMyAccountLinkAriaLabel: string;
    InstallDesktopAppsBtnText: string;
    InstallIndividualAppText: string;
    InstallOfficeAppsButtonText: string;
    InstallOfficeButtonAriaLabel: string;
    InstallOfficeButtonText: string;
    InstallOfficeDescription: string;
    InstallOfficeLinkText: string;
    InstallSoftwareButtonText: string;
    InstallText: string;
    InstallWizardCloseButtonAriaLabel: string;
    InstallWizardCloseButtonText: string;
    InstallWizardStep1DescriptionForChrome: string;
    InstallWizardStep1DescriptionForFirefox: string;
    InstallWizardStep1DescriptionForIE: string;
    InstallWizardStep1DescriptionForMac2011: string;
    InstallWizardStep1DescriptionForMac2016: string;
    InstallWizardStep1Title: string;
    InstallWizardStep1TitleForMac: string;
    InstallWizardStep2Description: string;
    InstallWizardStep2DescriptionForMac2011: string;
    InstallWizardStep2DescriptionForMac2016: string;
    InstallWizardStep2Title: string;
    InstallWizardStep2TitleForMac: string;
    InstallWizardStep3Description: string;
    InstallWizardStep3DescriptionForFallbackUrl: string;
    InstallWizardStep3DescriptionForMac2011: string;
    InstallWizardStep3DescriptionForMac2016: string;
    InstallWizardStep3Title: string;
    InstallWizardStep3TitleForFallbackUrl: string;
    InstallWizardStep3TitleForMac: string;
    InstallWizardSupportLinkAriaLabel: string;
    InstallWizardSupportLinkText: string;
    InstallWizardTitle: string;
    NeedHelpInstallingOfficeLnkText: string;
    InstallWizardRefreshStep1PC: string;
    InstallWizardRefreshStep2PC: string;
    InstallWizardRefreshStep3PC: string;
    InstallWizardRefreshStep1Mac: string;
    InstallWizardRefreshStep2Mac: string;
    InstallWizardRefreshStep3Mac: string;
    InstallWizardRefreshLearnAboutM365: string;
    GetStartedM365: string;
    NeedHelpText: string;
    GotItText: string;
    OfficeBrand2011Short: string;
    OfficeBrand2013Short: string;
    OfficeBrand2016Short: string;
    OfficeBrandShort: string;
    DesktopApp: string;
}

@Injectable({
    providedIn: 'root'
})
export class InstallConfigService {
    public readonly config: InstallConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<InstallConfig>('installConfig') || {
            consumerDirectInstallUrl: '',
            consumerInstallLink: '',
            consumerSSUInstallLink: '',
            commercialMySoftwarePageUrl: '',
            dimeEnabled: false,
            dimeJSUrl: '',
            dimeTimeoutMs: 5000,
            goPremiumUrl: '',
            goPremiumUrlPremiumTemplates: '',
            welcomeBadgeOneDriveUrl: '',
            installApiRoot: '',
            installApiSWEnabled: false,
            pwaInstallMoveEnabled: false,
            resources: null,
            sendRequestId: false,
            shellGoPremiumUrl: '',
            wizardImageAssets: '',
            wizardSupportLink: '',
            learnAboutM365Link: '',
            needHelpLink: '',
            buyOffice365Url: '',
            haveOfficeProductKeyUrl: '',
            needHelpInstallingOfficeUrl: '',
            ecsInstallNoLicenseOptionsEnabled: false,
            installMessagePopupEnabled: false,
            paidConsumerSubscriptionBenefitsUrl: ''
        };
    }
}
